import React, { useState, useEffect, useRef,useContext } from 'react';
import DynamicIcon from '../../components/dynamicicon';
import { Link, useNavigate,useParams  } from 'react-router-dom';
import * as Constants from '../../constants';
import { ShareContext } from '../../context/ShareContext';
import BackLoader from '../../components/backloader';
import JisButton from '../../components/controls/jisButton';
import CaseSearch from '../../components/core/case_search';
import JisEmptyList from '../../components/controls/emptylist';
import Pagenated from '../../components/pagenated';
import CaseDetails from '../../components/core/caseDetails';
import JisDialog from '../../components/dialog';
import JisYesNo from '../../components/controls/jisYesNo';
import JisCheckbox from '../../components/controls/jisCheckbox';
import JisDialogForm from '../../components/formdialog';
import JisPrepareTemplate from '../../components/core/preparetemplate';
import PdfViewer from '../../components/controls/pdfviewer';
import { s } from 'framer-motion/client';
import JisTabButton from '../../components/controls/jisTabButton';
import JisAlert from '../../components/jisalert';
import DeadlineBadge from '../../components/controls/deadlinebadge';
import * as Services from '../../services';
import JisPrepareTemplatePlain from '../../components/core/preparetemplate_plain';

function JudgeApprovalSales() {
     const navigate = useNavigate();
    const {  activePage, token, profile,frequentData,setIsExpired, setAlert} = useContext(ShareContext);
    const [cases, setCases] = useState([]);
    const [loading, setLoading] =useState(false);
    const [pageIndex, setPageIndex]=useState(0);
    const [pageSize,setPageSize] = useState(Constants.PAGESIZE);

    const [search, setSearch]=useState(null);
    const [err,setErr]=useState('');
     const [isPreview, setIsPreview] = useState(false);
     const [count,setCount] = useState(0);
    const [active, setActive] =useState(null);
    const [index, setIndex] = useState(-1);
    const [openCase,setOpenCase] =useState(false);

    const [selectedParty, setSelectedParty] =useState(null);
   
    const [caseParties, setCaseParties] = useState([]);
    const [template, setTemplate] = useState(null); 
    
    const [doc, setDoc] =useState(null)
    const [docline, setDocline] = useState(null);
    const [uplinetype, setUplinetype] = useState('attest');
    const [servedon, setServedOn] = useState(null);
    const [sFile, setSFile] =useState(null);
   
    const [previewPath, setPreviewPath] = useState(false);  
   
    
    const [claimants, setClaimants] = useState('');
    const [defendants, setDefendants] = useState('');
    const [autoFill, setAutoFill] = useState([]); //this is to hold the auto fill items
    const [tab, setTab] = useState('pending');
    const [otherAlert, setOtherAlert]=useState({open:false})

    const [warrant, setWarrant] = useState(null);
    const [warrants, setWarrants]= useState([]);
    const [doclines, setDoclines]=useState([]);
    const [isItems, setIsItems] = useState(false);
    const [isReport, setIsReport] = useState(false);
    const [collectedItems, setCollectedItems] = useState([]);
const [selectedWarrant, setSelectedWarrant] = useState(null);
 const [removingIndex, setRemovingIndex] = useState(null);
const [comData, setComData]=useState(null);
const [option, setOption] = useState(null);

    useEffect(() => {
      if(search!=null){
         if(pageIndex>=0){
           onSearch(search);
         }else{
            setPageIndex(0);
          }
      }
      
        onLoadTemplate();
      
          
    }, [pageIndex,pageSize,tab]);


       useEffect(() => {
      
        if( active!=null){
          //load the parties to the case
          onLoadParties(active.case?.caseId);
          onLoadWarrants(active.case?.caseId, active.id)
          
      
        }            
    }, [active]);

    const IsDefendant=(ptid)=>{
        const v = Constants.getItemById(frequentData.partyTypes,ptid).isLead;
        var m=v??false
        return !m;
    }



  useEffect(() => {
    if(active!=null && selectedParty!=null){
      console.log('in here befor template call')
      let fill=[{holder:'[DEFENDANT]',value:`${selectedParty.firstName} ${selectedParty.lastName??''}`},
        {holder:'[CLAIMANTS]',value:claimants},{holder:'[DEFENDANTS]', value:defendants}
      ]
    
      setAutoFill(fill);
       
           setSFile(null);  
        setIsPreview(false); 
    }         
    }, [selectedParty]);  

     useEffect(() => {
    if(active!=null && selectedWarrant!=null){
      console.log('in here befor template call')
       onLoadSelectedWarrant(active.id, selectedWarrant?.id)
    }         
    }, [selectedWarrant]);

   

  useEffect(() => {
    if(template!=null && servedon!=null  ){
      onSaveSelect();
    }         
    }, [template,servedon,uplinetype]);  



  const onSearch=async(sear)=>{ 
            setSearch(sear)       ;
            setLoading(true)
            try {
            
            const resp = await fetch(`${Constants.apiUrl}/filing/awaiting-judge-sales-approval/${pageIndex}/${pageSize}`, {
                method: 'POST',
                body:JSON.stringify(sear) ,
                headers: {
                'Content-Type': 'application/json, text/plain',
                Authorization: `Bearer ${token}`,
                },
            });
            
            const data = await resp.json();
            setLoading(false);
            console.log(data);
            if(data.code==0){
            //update the field
               setCases(data.items)
                if(pageIndex==0){
                setCount(data.totalCount)
               }
            }
             else if(data.code==-10){
                      setIsExpired(true);
                  }
                  else{
            //there is an error
            setErr(data.status);
            }
            
            } catch (error) {
            setLoading(false);
            console.error(error);
            setErr(Constants.serverErr);
            // onMove();
            }
        }

const onLoadParties= async(caseid)=>{
            //for account registration
        try {

            setLoading(true);
            const resp = await fetch(`${Constants.apiUrl}/filing/loadparties/${caseid}`, { 
                method: 'GET',  headers: {  'Content-Type': 'application/json','Authorization': `Bearer ${token}`,}, });  
            const data = await resp.json();
            setLoading(false);
            if(data.code==0){
                
              setCaseParties(data.parties);
              let claim=''; let defe='';
              data.parties.forEach(element => {
                if(IsDefendant(element.partyTypeId)){
                  
                  defe=defe+`${element.firstName} ${element.lastName??''},`
                  console.log(`in defendant loop ${defe}`)
                }else{
                  
                  claim=claim+`${element.firstName} ${element.lastName??''},`
                  console.log(`in claimant loop ${claim}`)
                }
              });
              setDefendants(defe);
              setClaimants(claim);
            } else if(data.code==-10){
                      setIsExpired(true);
                  }
            
            } catch (error) {
            setLoading(false);
            console.error(error);   
            }
        }
        const onLoadSelectedWarrant= async(writid,warrantlineid)=>{
            //for account registration
        try {

            setLoading(true);
            const resp = await fetch(`${Constants.apiUrl}/filing/get-warrantline-details/${writid}/${warrantlineid}`, { 
                method: 'GET',  headers: {  'Content-Type': 'application/json','Authorization': `Bearer ${token}`,}, });  
            const data = await resp.json();
            setLoading(false);
            if(data.code==0){
                
            setCollectedItems(data.collected);
              
            } else if(data.code==-10){
                      setIsExpired(true);
                  }
            
            } catch (error) {
            setLoading(false);
            console.error(error);   
            }
        }
    const onLoadTemplate= async()=>{
            //for account registration
        try {

            setLoading(true);
            const resp = await fetch(`${Constants.apiUrl}/filing/load-special-template/warrant-execution-report`, { 
                method: 'GET',  headers: {  'Content-Type': 'application/json','Authorization': `Bearer ${token}`,}, });  
            const data = await resp.json();
            setLoading(false);
            if(data.code==0){
                
              setTemplate(data.temp);
              
              
            } else if(data.code==-10){
                      setIsExpired(true);
                  }
            
            } catch (error) {
            setLoading(false);
            console.error(error);   
            }
        }    
    const onLoadWarrants = async(caseid, writid)=>{
            //for account registration
        try {
          
            setLoading(true);
            const resp = await fetch(`${Constants.apiUrl}/filing/get-signed-warrants/${caseid}/${writid}`, { 
                method: 'GET',  headers: {  'Content-Type': 'application/json','Authorization': `Bearer ${token}`,}, });  
            const data = await resp.json();
            setLoading(false);
            if(data.code==0){
             setWarrant(data.warrant);
             setWarrants(data.warrants);
             setDoclines(data.doclines);

            } else if(data.code==-10){
                      setIsExpired(true);
                  }
            
            } catch (error) {
            setLoading(false);
            console.error(error);   
            }
        }
    const onPagePick=(pick)=>{
    console.log('this is selection value');
    setPageIndex(pick.id-1)
    console.log(pick)
  }

    const onContinue=(item,ind)=>{
        //navigate(`/case-details/${caseid}`)
        const division=Constants.getItemById(frequentData?.divisions,item.case.divisionId)?.title
        var _item={...item, 
          division,
       caseType: item.case?.caseFilingId==1?'litigation':'adr',type:'document' }
        setActive(_item);
        console.log(`on continue ${division}`)
        console.log(_item);
        setIndex(ind);
        setOpenCase(true);
    }

    const onCloseOpenCase=()=>{
    setActive(null);
    setIndex(-1);
    setOpenCase(false);
    }

    const onCloseEntries=()=>{
      setActive(null);
      setIsItems(false)
      setIndex(-1);
      setWarrant(null);
        setWarrants(null);
        setDoclines(null);
 
    }
    const onCollectItems=(item,ind)=>{
      setIndex(ind);
      setActive(item);
      setIsItems(true)
    }
    const onSheriffReport=(item,ind)=>{
        //navigate(`/case-details/${caseid}`)
      
        setActive(item);
        setIndex(ind);
        setIsReport(true);
    }
   const onSelectWarrant=(opt)=>{
    setSelectedWarrant(opt);
   }

 const onSaveSelect=async()=>{

        
              
            setLoading(true)
            try {
            
                const resp = await fetch(`${Constants.apiUrl}/filing/save-service-sherif-substituted/select`, {
                method: 'POST',
              //  body:JSON.stringify(select) ,
                headers: {
                'Content-Type': 'application/json, text/plain',
                Authorization: `Bearer ${token}`,
                },
            });
            
            const data = await resp.json();
          
            if(data.code==0){
            //update the field
               
                
            } else if(data.code==-10){
                setIsExpired(true);
            }else{
            //there is an error
            setErr(data.status);
            }
            
            } catch (error) {
            setLoading(false);
            console.error(error);
            setErr(Constants.serverErr);
            // onMove();
            }
       } 


 const handleUploadChange =async (e) => {
 
        const files = e.target.files;
        console.log(files[0]);
        var b64=await Constants.toBase64(files[0]);
        var path =URL.createObjectURL(files[0]);
        var fname=Constants.ReduceFilename(files[0]?.name);

       var a={ path, base64:b64.split(',')[1],filename: fname, base64Ext:b64.split(',')[0]};

       setSFile(a);
      
    };
const onPreview=(obj)=>{
        setIsPreview(true);
        setPreviewPath(obj.path);
     }

const onUploadFiles2= async(caseid,partyid)=>{
        const uploadurl=`${Constants.apiUrl}/filing/upload-service-sheriff-document/${caseid}/${partyid}`
        var upline={
               
                uplineType: "non-attest",
                base64: sFile.base64,
                base64Ext: sFile.base64Ext,
                templateId:0,
                templatetitle: "",
                filename:sFile.filename,
             
                }

      //  setFlowError('');

            // Sending the FormData using fetch
            setLoading(true);
            fetch(uploadurl, {
            method: 'POST',
            body: JSON.stringify(upline),
            headers: {
                'Content-Type': 'application/json, text/plain',
                Authorization: `Bearer ${token}`,
                },
            })
            .then(response => response.json())
            .then(data => {
                setLoading(false);
                if(data.code==0){
                  
                } else if(data.code==-10){
                      setIsExpired(true);
                  }
            })
            .catch(error => {
                console.error('Error:', error);
                setLoading(false);
        });
    }

const onChangePrepare=(holdervalues,html,isLegal)=>{
     
  //  setComData({html,holdervalues });

  }
  const onInstumentAppended=(e)=>{
    //after saving of instrument, this is what you get
      if(e.code==0){
              //saved already   
          }
  }

const onPrepareDone=(e)=>{
  //this is coming from from Prepare Document
  console.log('in service sherrif');
 
  //load the attached parties that are defendant, check total service created for them,
  //  then go ahead and close the window and set the the servicestatus to awaitingcfo
onUpdateStatus();
   /* var defendants=caseParties?.filter((k)=> IsDefendant(k.partyTypeId) ).length;
   if(defendants==services.length || defendants==1){
    
   } */
    
}
const onUpdateStatus=async()=>{
           
            setLoading(true)
            try {
            
                const resp = await fetch(`${Constants.apiUrl}/filing/service-sheriff-substituted-update/${active?.caseId}`, {
                method: 'POST',
               // body:JSON.stringify(approve) ,
                headers: {
                'Content-Type': 'application/json, text/plain',
                Authorization: `Bearer ${token}`,
                },
            });
            
            const data = await resp.json();
            setLoading(false);
            
            if(data.code==0){
              
            
              
            } else if(data.code==-10){
                setIsExpired(true);
            }
            
            } catch (error) {
            setLoading(false);
            console.error(error);
           
            // onMove();
            }
       } 




const onVerifyStay=async()=>{ 
        setLoading(true);
          const verified = await Services.onVerifyStayOfExecution(active.case?.caseId);
          console.log('verification result motion'+verified)
          setActive({...active,verified_motion:verified});
          setLoading(false);
        }

const onVerifyAppeal=async()=>{
        setLoading(true);
          const verified = await Services.onVerifyAppeal(active.case?.caseId);
          console.log('verification result appeal'+verified)
          setActive({...active,verified_appeal:verified});
          setLoading(false);
        }

  const onChangeCollected = (index, key, value) => {
  setCollectedItems(prev =>
    prev.map((item, i) => i === index ? { ...item, [key]: value } : item)
  );
};

const onRemoveCollected = async (index) => {
    if(collectedItems.length==1){
        return;
    }

    /* const h=claims[index];
        if(h && h.id>0){
            await onRemoveClaim_Server(h.id);
        } */
     setRemovingIndex(index);
  setTimeout(() => {
    setCollectedItems(prev => prev.filter((_, i) => i !== index));
    setRemovingIndex(null);
  }, 300); // match fadeOut duration

 
};

const onVerifyCollection=async(e)=>{
             e.preventDefault();

         

              var approve={...option,writId:active.id, source:'keeper' };
            
            setLoading(true)
            try {
            
                const resp = await fetch(`${Constants.apiUrl}/filing/post-judgement-clear/${active.id}`, {
                method: 'POST',
                body:JSON.stringify(approve) ,
                headers: {
                'Content-Type': 'application/json, text/plain',
                Authorization: `Bearer ${token}`,
                },
            });
            
            const data = await resp.json();
            setLoading(false);
            console.log(data);
            if(data.code==0){
            //update the field
                setIsItems(false)
                const ft=cases.filter((_, i) => i !== index)
                setCases(ft );
               setAlert({open:true, title:'Clear Case', subtitle:'Case moved to Chief Judge successfully'});
                
            } else if(data.code==-10){
                setIsExpired(true);
            }else{
            //there is an error
            setErr(data.status);
            }
            
            } catch (error) {
            setLoading(false);
            console.error(error);
            setErr(Constants.serverErr);
            // onMove();
            }
       } 


const onOptionChange = (e) => {
    setOption({...option, [e.target.name]: e.target.value})
}

  return (
    <div>
     
      <CaseSearch onSearch={onSearch} frequentData={frequentData} />

      <div className='tab_body'>
<div className='tab_section'>
     
        </div>
        <div className='tab_view'>
{cases?.length==0 && <JisEmptyList/>}
{cases?.length>0 && 
<div className='table'>
  <div class="section-cases">
  <span>Execution Sherrif </span>
</div>
      <table class="case-table">
  <thead>
    <tr>
      <th className="col-title">Suit Number</th>
      <th className="col-title">Case Title</th>
      <th className="col-medium">Filing Type</th>
      <th className="col-medium">Classification</th>
      <th className="col-medium">Date Initiated</th>
      <th className="col-medium">Status Level</th>
   <th>SLA</th>
      <th className="col-title">Details</th>
     { <th className="col-action">Action</th>} 
     
    </tr>
  </thead>
  <tbody>
     {cases?.map((opt, index) => {

      return (
      <tr key={index}>
            <td style={{backgroundColor:`${Constants.getItemById(frequentData?.casecategories,opt?.case?.caseCategoryId)?.colour}`}}>{opt?.case?.caseNumber}</td>
      <td >{opt.case?.caseTitle}</td>
       <td>{Constants.getItemById(frequentData?.casetype,opt?.case?.caseTypeId)?.caseType1}</td>
      <td> {Constants.getItemById(frequentData?.casecategories,opt?.case?.caseCategoryId)?.categoryTitle}</td>
      <td> {Constants.momentDate(opt?.case?.createdOn).format('DD MMM, YYYY')}</td>
      <td>{Constants.getItemById(frequentData?.casestatuses,opt?.caseStatusId)?.description}</td>
      <td><DeadlineBadge dateString={opt?.slaExpire}/> </td>
      <td><JisButton variant='plain' onClick={()=>onContinue(opt,index)}>View</JisButton></td>
     <td><JisButton variant='plain' onClick={()=>onCollectItems(opt,index)}>Verify Collected Items</JisButton></td>
     
      
    </tr>
    )})} 
    


  </tbody>
</table>
{cases?.length>0 && <Pagenated onChangePageSize={(k)=>setPageSize(k)} size={pageSize} total={count} maxPage={20}  onPick={onPagePick}/>}    
</div>}
        </div>
      </div>

<BackLoader open={loading} />
{otherAlert.open && <JisAlert {...otherAlert} />}
  {openCase && active!=null && <JisDialogForm title="Case Info" onClose={onCloseOpenCase}>
    <div>
      <CaseDetails  caseId={active.caseId} data={null} token={token} initialtab="casedocuments" />
    </div>
    </JisDialogForm> }

   {isItems && active!=null && <JisDialogForm title="Entered Collected Items" onClose={onCloseEntries}>
    <div>
<form onSubmit={onVerifyCollection}> 
     
      <div style={{ flex: 1, display: "flex", flexDirection: "row" }}>
          {warrants.map((opt) => (
              <div
                key={opt.id}
                className={`selected ${
                  opt.id == selectedWarrant?.id ? "active" : ""
                }`}
                onClick={() => onSelectWarrant(opt)}
                style={{ maxWidth: "40%" }}
              >
                {opt.location} - {opt.warrantType}
              </div>
            ))}
        </div>
        <div>Active Warrant: {selectedWarrant?.location}</div>
        <div>Item Collected</div>

        {  <div className='view'>
       
            {collectedItems.map((collected, index) => (
            <div key={index} className={`claim-item ${removingIndex === index ? 'removing' : ''}`}>
                <div style={{ flex: 1, display:'flex' }}>
                
                <div  className="input-group">
                        <label>  Item Title  </label>
                        <div className='input-wrapper'>
                            <DynamicIcon iname="group" />
                            <input placeholder='e.g Lexus 2025' readOnly={true}  value={collected.itemTitle}
                    onChange={(e) => onChangeCollected(index, 'itemTitle', e.target.value)}   />
                        </div>
                    </div>
<div  className="input-group">
                        <label>  Item Description  </label>
                        <div className='input-wrapper'>
                            <DynamicIcon iname="group" />
                            <input placeholder='e.g Item description' readOnly={true}  value={collected.itemDesc}
                    onChange={(e) => onChangeCollected(index, 'itemDesc', e.target.value)}   />
                        </div>
                    </div>
<div  className="input-group">
                        <label>  Item Quantity  </label>
                        <div className='input-wrapper'>
                            <DynamicIcon iname="group" />
                            <input placeholder='e.g Item quantity' readOnly={true}  value={collected.itemQty}
                    onChange={(e) => onChangeCollected(index, 'itemQty', e.target.value)} type="number"  />
                        </div>
                    </div>
                  <div  className="input-group">
                        <label>  Item Type  </label>
                        <div className='input-wrapper'>
                            <DynamicIcon iname="group" />
                            <input placeholder='e.g Money or Goods or Properties' readOnly={true}  value={collected.itemType}
                    onChange={(e) => onChangeCollected(index, 'itemType', e.target.value)}   />
                        </div>
                    </div>
                  <JisCheckbox label="Check If Item is perishable" 
                  value={collected.isPerishable} 
                  onChange={(e) => onChangeCollected(index, 'isPerishable', e)} />  

                </div>
              
            </div>
        ))}
       
        </div>}



        <div  className="input-group">
            <label>Comment <span className="required">*</span> </label>
            <div className='input-wrapper'>
                <DynamicIcon iname="group" />
                <textarea placeholder=' Comment' name='comment' required={true}  value={option?.comment}
        onChange={onOptionChange}  />
            </div>
        </div> 
  <div className='flowbuttongroup'>
                        
                        <JisButton type='submit' loading={loading}>Verify Items</JisButton>
                    </div> 
       {err!='' && <div className='error'>{err}</div>}             
</form>
    </div>
    </JisDialogForm> } 

 
    </div>
  );
}

export default JudgeApprovalSales;